// constants
import { SELECTORS } from '@/scripts/constants';

// others
import { isMobile } from '@/scripts/helper';

// assets
import './UltraHover.scss';


const defaults = {
  element: null,
  overlay: '[data-role="hover-overlay"]',
  activeClass: SELECTORS.active,
};

export class UltraHover {
  constructor(props) {
    if (isMobile()) {
      return;
    }
    const options = Object.assign({}, defaults, props);
    if (!options.element) {
      return;
    }

    this.element = options.element;
    this.overlay = document.createElement('span');
    this.element.appendChild(this.overlay);

    if (!this.overlay) {
      return;
    }

    this.element.classList.add('ultra-hover');
    this.overlay.classList.add('ultra-hover__overlay');

    this.activeClass = options.activeClass;

    this.mouseEnter = this.mouseEnter.bind(this);
    this.mouseLeave = this.mouseLeave.bind(this);
    this.init();
  }

  updateOverlay(e) {
    const { offsetWidth, offsetHeight } = this.element;
    const { left, top } = this.element.getBoundingClientRect();
    const itemLeft = left + window.scrollX;
    const itemTop = top + window.scrollY;
    const size = Math.sqrt(offsetWidth ** 2 + offsetHeight ** 2);
    this.overlay.style.width = `${size}px`;
    this.overlay.style.height = `${size}px`;

    const overlayX = Math.round(e.pageX - itemLeft) - (size / 2);
    const overlayY = Math.round(e.pageY - itemTop) - (size / 2);

    this.overlay.style.top = `${overlayY}px`;
    this.overlay.style.left = `${overlayX}px`;
  }

  mouseEnter(e) {
    this.overlay.classList.remove(this.activeClass);
    this.updateOverlay(e);
    this.overlay.classList.add(this.activeClass);
  }

  mouseLeave(e) {
    this.updateOverlay(e);
    this.overlay.classList.remove(this.activeClass);
  }

  init() {
    this.element.addEventListener('mouseenter', this.mouseEnter);
    this.element.addEventListener('mouseleave', this.mouseLeave);
  }
}
